import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TitleStrategy } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app.component';

import { JuridicoHeader } from './juridico/includes/header.component';
import { JuridicoFooter } from './juridico/includes/footer.component';
import { LoginJuridicoComponent } from './juridico/paginas/login/login.component';

import { RecuperarSenhaComponent } from './ambos/paginas/recuperar-senha/recuperar-senha.component';

import { HttpClientModule }  from '@angular/common/http';

import { AuthService } from './services/auth.service';
import { ModalDefinirContaComponent } from './components/modal-definir-conta/modal-definir-conta.component';
import { FormularioLoginModule } from './components/formulario-login/formulario-login.module';
import { NaoEncontradaComponent } from './juridico/paginas/nao-encontrada/nao-encontrada.component';
import { CancelarEnvioEmailComponent } from './juridico/paginas/cancelar-envio-email/cancelar-envio-email.component';
import { UsuarioNaoEncontradoComponent } from './juridico/paginas/usuario-nao-encontrado/usuario-nao-encontrado.component';
import { FilterPipe } from './filter.pipe';
import { CookiesComponent } from './components/cookies/cookies.component';

import { NgxMaskModule } from 'ngx-mask'

// Datapicker Angular Material
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule  } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateMaskInputDirective } from 'src/app/directives/date-mask-input.directive';
import { LocationStrategy, Location, PathLocationStrategy } from '@angular/common';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@NgModule({
    declarations: [
        AppComponent,
        JuridicoHeader,
        JuridicoFooter,
        LoginJuridicoComponent,
        RecuperarSenhaComponent,
        NaoEncontradaComponent,
        CancelarEnvioEmailComponent,
        UsuarioNaoEncontradoComponent,
        FilterPipe,
        CookiesComponent,
        DateMaskInputDirective,
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        AppRoutingModule,
        FontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        NgbModule,
        FormularioLoginModule,
        NgxMaskModule.forRoot(),
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule
    ],
    providers: [
        AuthService,
        ModalDefinirContaComponent,
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        //{ provide: LocationStrategy, useClass: PathLocationStrategy } 
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
